module.exports = __webpack_public_path__ + "static/media/corknscrew-cover.be7bf59a.jpg";